import React from "react";
import { FormattedMessage } from "react-intl";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import globeSettingIcon from "../../../assets/settings/globe.svg";

import styles from "./SettingsLanguages.module.css";
import SelectInput from "../../Shared/SelectInput/SelectInput";
import { Form } from "react-bootstrap";
import { KeyValue } from "../../../models/key-value";

const SettingsLanguages = () => {
  const languages: KeyValue<string>[] = [
    {
      key: "SETTINGS.LANGUAGES.ENGLISH",
      value: "English (United States)",
    },
  ];

  return (
    <div className="container">
      <Form.Row className="mb-2 d-flex align-items-center">
        <div className="d-flex align-items-center">
          <BaseIcon className="" icon={globeSettingIcon} />
          <span className="mx-1"></span>
          <p className={`${styles.title} mb-0`}>
            <FormattedMessage
              id="SETTINGS.LANGUAGES"
              defaultMessage="Languages"
            />
          </p>
        </div>
        <div className="col d-flex flex-grow-1">
          <SelectInput items={languages} onChange={() => {}} />
        </div>
      </Form.Row>
    </div>
  );
};

export default SettingsLanguages;
